import { createEnumMapper } from '@/utils/enumUtils'

export enum MessageType {
  ALL = 0,
  TEXT = 5,
  IMAGE = 1,
  VIDEO = 2,
  TABLE = 3,
  NOTICE = 4,
  GAME = 6,
  ANNOUNCEMENT = 7,
  AUDIO = 8
}

const messageTypeLabelMap = {
  [MessageType.ALL]: '不限',
  [MessageType.TEXT]: '文本',
  [MessageType.IMAGE]: '图片',
  [MessageType.VIDEO]: '视频',
  [MessageType.TABLE]: '表格',
  [MessageType.NOTICE]: '通知',
  [MessageType.GAME]: '游戏',
  [MessageType.ANNOUNCEMENT]: '公告',
  [MessageType.AUDIO]: '语音'
} as const

export const MessageTypeMapper = createEnumMapper(MessageType, messageTypeLabelMap)
